import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";
import {
  FilterParams,
  getEvacuationDrill,
  getFacilityVacancyListByPlaceIdHashList,
  getPlaceListByLocation,
} from "../adapter.api";
import { ResponseGetEvacuationDrillMode } from "@/@types/evacuation-drill";

export class PlaceService {
  static async fetchPlaceListByLocation({
    lat,
    lng,
    radius,
    countryName,
    params,
    areaName,
    mapType,
    isOpendata,
  }: {
    lat: number;
    lng: number;
    radius: number; // meter
    countryName: string;
    params: FilterParams;
    areaName?: string;
    mapType?: string;
    isOpendata?: boolean;
  }): Promise<PortalAdapterApi.ResponseGetPublicPlace[]> {
    const convertedAreaName: string | undefined =
      areaName === "Default" || areaName === "current-place" || areaName === "unknown" || !areaName
        ? undefined
        : areaName;

    return getPlaceListByLocation({
      lat,
      lng,
      radius,
      countryName,
      params,
      areaName: convertedAreaName,
      mapType,
      isOpendata,
    });
  }

  static fetchFacilityVacancyListByPlaceIdHashList(
    placeIdHashList: string[],
  ): Promise<PortalAdapterApi.ResponseGetMergedDisplayVacancy[]> {
    return getFacilityVacancyListByPlaceIdHashList(placeIdHashList);
  }

  static fetchEvacuationDrill(placeIdHashList: string[]): Promise<ResponseGetEvacuationDrillMode[] | undefined> {
    return getEvacuationDrill(placeIdHashList);
  }
}
